import ChartTypes from '../constants/chart_types';

export default class ChartData {
	_type;
	_width;
	_height;
	_dataFormat;
	_xmlPath;
	_isLinkToView;

	constructor({ type = ChartTypes.COLUNA_SIMPLES, width, height, dataFormat = 'xml', xmlPath, isLinkToView}) {
		this._type = type;
		this._width = width;
		this._height = height;
		this._dataFormat = dataFormat;
		this._xmlPath = xmlPath;
		this._isLinkToView = isLinkToView;
	}

	get type() {
		return this._type;
	}

	set type(value) {
		this._type = value;
	}

	get width() {
		return this._width;
	}

	set width(value) {
		this._width = value;
	}

	get height() {
		return this._height;
	}

	set height(value) {
		this._height = value;
	}

	get dataFormat() {
		return this._dataFormat;
	}

	set dataFormat(value) {
		this._dataFormat = value;
	}

	get xmlPath() {
		return this._xmlPath;
	}

	set xmlPath(value) {
		this._xmlPath = value;
	}

	get isLinkToView() {
		return this._isLinkToView;
	}

	set isLinkToView(value){
		this._isLinkToView = value;
	}
}
